/* eslint-disable */


/**
 * Create styles for `<Page />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Page />` styles
 */
const pageStyles = ({ theme }) => ({
  alwaysCenter: {
    display: `block`,
    margin: `0 auto`,
    overflow: `auto`,
    [theme.breakpoints.up(`md`)]: {
      paddingLeft: 0,
    },
  },
  root: {
    display: `flex`,
    flexDirection: `column`,
    height: `100%`,
    overflow: `hidden`,
    position: `relative`,
    [theme.breakpoints.up(`md`)]: {
      paddingLeft: 256,
    },
  },
  rootWithoutPadding: {
    paddingLeft: 0,
  },
  sidebarMain: {
    display: `flex`,
    height: `100%`,
    left: 0,
    position: `fixed`,
    top: 0,
    zIndex: 999999,
  },
});

export default pageStyles;
